// extracted by mini-css-extract-plugin
module.exports = {"container":"partials-notebook-cards-container","select":"partials-notebook-cards-select","items":"partials-notebook-cards-items","single":"partials-notebook-cards-single"};